// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  message: 'You\'re in Dev'
};

export const url = {
   base: 'https://stagings.vaps.parkwayprojects.xyz/Vaps.API/api/v1/',
   v2: 'https://stagings.vaps.parkwayprojects.xyz/Vaps.API/api/v2/',
   kyc: 'https://stagings.vaps.parkwayprojects.xyz/accountcategorization.api/api/',
   web: 'https://staging.vaps.parkwayprojects.xyz/',
   cloudinary: 'https://res.cloudinary.com/demo/image/fetch/q_auto,f_auto/',
   analyticsId: 'G-YBM61BY72T'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
